import * as React from "react";
import { observer } from "mobx-react";
import { Redirect, RouteComponentProps, withRouter } from "react-router-dom";
import MuiCircularProgress from "@mui/material/CircularProgress";

// Source
import { store } from "../../store";
import { ROUTE_TYPE } from "../../HelperSrc";
import { lang } from "../../lang";
import { logLogin } from "../../actions/logLogin";
import { Template } from "../../components/organisms/Template";
import { catchEndpoint } from "../../catchEndpoint";

@observer
class ClientsPageBase extends React.Component<RouteComponentProps> {
    state = {
        selectedClient: null
    };

    public componentDidMount() {
        const { groupnames } = store.user;

        if (groupnames?.length === 0 && !store.user.is_superuser && !store.showNotice) {
            store.doNotice(lang.noClientsError);
            store.setDB(null);
        }
    }

    public selectClient(client: string[]) {
        store.selectClient(String(client[0]), String(client[1]));
        this.setState({
            selectedClient: client[0]
        });
    }

    public render() {
        if (!store.user.id) {
            return <Redirect to={ROUTE_TYPE.LOGOUT} />;
        }

        const { groupnames } = store.user;

        if (!groupnames) {
            return (
                <div className="loader fullscreen">
                    <MuiCircularProgress style={{ margin: "0px 8px", color: "#fff" }} size={18} />
                </div>
            );
        }

        if (store.db && store.db == this.state.selectedClient) {
            logLogin().catch(catchEndpoint);
            return <Redirect to={ROUTE_TYPE.WORKBOOKS} />;
        }

        return (
            <Template>
                <div data-at_id="client_page_container" className="client_page_container">
                    <div className="card_title">Select Client</div>
                    <div className="card_container">
                        {groupnames.map((e, i) => {
                            const parts = e.split("_");
                            return (
                                <div
                                    className="dbpanel"
                                    data-at_id={`client_item_${parts[0]}`}
                                    key={i}
                                    onClick={() => {
                                        this.selectClient(parts);
                                    }}
                                >
                                    {parts[0]}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Template>
        );
    }
}

const ClientsPage = withRouter(ClientsPageBase);

export { ClientsPage };
